<template>
    <div class="container">
        <div class="box">
            <div class="box-wrap">
                <div class="item">
                    <p
                        class="reveal-bottom"
                        :style="lang === 'en_US' ? 'line-height:30px' : ''"
                    >
                        {{ $t("gaa.c") }}
                        <br />
                        <br />
                        {{ $t("gaa.c1") }}
                    </p>
                </div>
                <div class="item">
                    <img class="item-img" :src="img" alt="col" />
                </div>
                <div class="item">
                    <img class="item-img" :src="img1" alt="col" />
                </div>
                <div
                    class="item reveal-bottom"
                    :style="lang === 'en_US' ? 'line-height:36px' : ''"
                >
                    {{ $t("gaa.c2") }}<br />
                    <br />
                    <span style="font-size:46px">{{ $t("gaa.c3") }}</span>
                    <br />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "content2",
    data() {
        return {
            lang: localStorage.getItem("lang"),
            img: require("@/assets/images/global_app_access_img_2.jpg"),
            img1: require("@/assets/images/global_app_access_img_3.jpg"),
        };
    },
    mounted() {
        this.$bus.$on("lang", (lang) => {
            this.lang = lang;
        });
    },
};
</script>
<style scoped>
.container {
    overflow: hidden;
    background-color: #fff;
}
.box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
}

.box-wrap {
    display: flex;
    flex-wrap: wrap;
}
.item {
    width: 590px;
    height: 456px;
    box-sizing: border-box;
}
.item:nth-child(1) {
    background: #00a3d1;
}
.item-img {
    width: 100%;
    height: 100%;
}
.item:nth-child(1) > p {
    width: 450px;
    height: 100%;
    float: right;
    padding-right: 40px;
    box-sizing: border-box;
    font-size: 24px;
    color: #ffffff;
    line-height: 44px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.item:nth-child(4) {
    padding: 40px;
    box-sizing: border-box;
    font-size: 24px;
    color: #000;
    line-height: 45px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/Pages/GlobalAppAccess/Content0.vue